export function ShowPassonrdIcon({ mainClassName, fillClassName }) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
      viewBox="0 0 20 20"
    >
      <path
        d="M10 15a9.187 9.187 0 01-2.335-.287 10.151 10.151 0 01-2.025-.745c-.62-.31-1.174-.652-1.664-1.027a9.648 9.648 0 01-1.251-1.124 6.534 6.534 0 01-.787-1.044c-.18-.322-.271-.58-.271-.776 0-.196.09-.452.27-.77.186-.317.448-.664.788-1.038a9.38 9.38 0 011.25-1.13 10.359 10.359 0 013.69-1.772A9.187 9.187 0 0110 5c.839 0 1.626.096 2.36.287a10.116 10.116 0 013.69 1.772c.49.374.905.751 1.245 1.13.34.374.598.72.774 1.038.176.318.264.574.264.77 0 .195-.088.454-.264.776a5.912 5.912 0 01-.774 1.044c-.34.375-.753.75-1.238 1.124a10.109 10.109 0 01-3.696 1.772A9.343 9.343 0 0110 15zm.007-1.918c.451 0 .872-.082 1.264-.245a3.43 3.43 0 001.045-.665 3.11 3.11 0 00.703-.984 2.78 2.78 0 00.258-1.185c0-.57-.149-1.087-.445-1.552a3.173 3.173 0 00-1.18-1.111 3.308 3.308 0 00-1.645-.416 3.32 3.32 0 00-1.652.416c-.494.272-.89.641-1.186 1.105a2.863 2.863 0 00-.439 1.558c.004.558.153 1.071.445 1.54.297.464.69.836 1.18 1.117a3.283 3.283 0 001.652.422zM10 11.2a1.27 1.27 0 01-.896-.348 1.138 1.138 0 01-.368-.849c0-.326.122-.607.368-.843.249-.236.548-.354.896-.354.353 0 .652.118.897.354.249.236.374.517.374.843 0 .33-.125.613-.374.85A1.255 1.255 0 0110 11.2z"
        fill="#D1D4DA"
        className={fillClassName}
      />
    </svg>
  );
}

export function HidePassonrdIcon({ mainClassName, fillClassName }) {
  return (
    <svg
      width={20}
      height={20}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
      viewBox="0 0 20 20"
    >
      <path
        d="M10 14.664a9.972 9.972 0 01-2.335-.264 10.755 10.755 0 01-3.69-1.624 9.416 9.416 0 01-1.25-1.031 6.064 6.064 0 01-.787-.958c-.18-.295-.271-.532-.271-.712 0-.205.118-.483.355-.834.24-.355.584-.736 1.031-1.143a9.05 9.05 0 011.6-1.143L7.001 8.99a2.558 2.558 0 00-.2.526c-.047.183-.071.372-.071.566.004.512.153.982.445 1.412.297.426.69.767 1.18 1.025a3.518 3.518 0 001.652.387 3.547 3.547 0 001.232-.23l1.786 1.546a10.503 10.503 0 01-3.025.443zm5.47-1.513l-2.413-2.106c.073-.15.127-.305.162-.465a2.432 2.432 0 00-.387-1.922 3.078 3.078 0 00-1.18-1.02 3.547 3.547 0 00-1.645-.38 3.594 3.594 0 00-1.11.173L7.123 5.896A10.423 10.423 0 0110 5.493c.839 0 1.626.088 2.36.263.736.172 1.413.4 2.033.684.619.284 1.171.597 1.657.94.49.344.905.69 1.245 1.037.34.344.598.661.774.953.176.291.264.526.264.706 0 .209-.116.487-.348.834-.228.348-.557.721-.987 1.12-.43.397-.94.77-1.528 1.121zm-7.457-3.12v-.068a.482.482 0 00.007-.078l2.096 1.815a.592.592 0 00-.084.006h-.077c-.353 0-.677-.075-.974-.224a1.926 1.926 0 01-.703-.611 1.442 1.442 0 01-.264-.84zm3.96-.062a.356.356 0 01-.006.067v.068l-2.07-1.799a.499.499 0 01.07-.005h.078c.357 0 .68.074.968.224.292.15.524.35.696.605.177.254.265.534.265.84zm2.923 4.908L4.376 5.75a.391.391 0 01-.142-.308c0-.127.047-.232.142-.314A.532.532 0 014.736 5c.143 0 .263.043.362.129l10.514 9.12a.395.395 0 01.148.308c0 .12-.05.226-.149.32a.51.51 0 01-.36.123.537.537 0 01-.355-.123z"
        fill="#D1D4DA"
        className={fillClassName}
      />
    </svg>
  );
}

export function LogoIcon({ mainClassName }) {
  return (
    <svg
      width={166}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
      viewBox="0 0 166 40"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.189 0v39.454h7.09V0h-7.09zm49.038 40c-2.382 0-4.528-.6-6.44-1.8-1.913-1.201-3.41-2.839-4.492-4.912-1.083-2.074-1.624-4.402-1.624-6.985 0-2.62.541-4.966 1.624-7.04 1.082-2.073 2.579-3.71 4.492-4.911 1.912-1.2 4.058-1.8 6.44-1.8 1.876 0 3.554.381 5.033 1.145a8.984 8.984 0 012.543 1.934v-2.534h7.036v26.357h-7.036v-2.558a9.697 9.697 0 01-2.543 1.958c-1.479.764-3.157 1.146-5.033 1.146zm1.299-6.603c1.984 0 3.59-.655 4.816-1.964 1.227-1.347 1.84-3.075 1.84-5.185 0-1.382-.288-2.6-.866-3.656-.541-1.091-1.316-1.928-2.327-2.51-.974-.619-2.128-.928-3.463-.928-1.299 0-2.454.31-3.464.928-.974.582-1.75 1.419-2.327 2.51-.541 1.055-.812 2.274-.812 3.656 0 1.42.271 2.674.812 3.766a6.753 6.753 0 002.327 2.51c1.01.582 2.165.873 3.464.873zm-38.807 1.965l12.232-16.044H74.693v-6.22h21.432v4.092L83.893 33.234H95.8v6.22H73.72v-4.092zM43.661 40c-2.634 0-5.015-.6-7.144-1.801a14.36 14.36 0 01-5.033-4.966c-1.227-2.11-1.84-4.456-1.84-7.04 0-2.582.613-4.893 1.84-6.93 1.227-2.074 2.904-3.71 5.033-4.911 2.129-1.237 4.492-1.856 7.09-1.856 2.67 0 5.05.619 7.144 1.856 2.128 1.2 3.806 2.837 5.033 4.911 1.226 2.037 1.84 4.348 1.84 6.93 0 2.584-.614 4.93-1.84 7.04-1.227 2.074-2.905 3.73-5.033 4.966-2.093 1.2-4.456 1.8-7.09 1.8zm-.054-6.658c1.335 0 2.507-.29 3.517-.873a6.108 6.108 0 002.382-2.51c.577-1.091.866-2.328.866-3.71 0-1.383-.289-2.602-.866-3.657a6.212 6.212 0 00-2.382-2.456c-1.01-.618-2.182-.927-3.517-.927-1.3 0-2.454.309-3.464.927a6.213 6.213 0 00-2.381 2.456c-.578 1.055-.866 2.274-.866 3.656 0 1.383.288 2.62.866 3.71a6.609 6.609 0 002.381 2.511c1.01.582 2.165.873 3.464.873zM7.36 25.212v14.242H0V1.091h14.991c2.418 0 4.582.492 6.494 1.474 1.949.982 3.482 2.383 4.6 4.202 1.12 1.782 1.678 3.91 1.678 6.385 0 2.473-.559 4.62-1.677 6.439-1.119 1.782-2.652 3.165-4.6 4.147-1.913.983-4.078 1.474-6.495 1.474h-7.63zm0-18.063v12.005h6.873c1.155 0 2.201-.236 3.14-.71a5.434 5.434 0 002.218-2.018c.541-.91.812-2.001.812-3.274 0-1.237-.27-2.31-.812-3.22a5.322 5.322 0 00-2.219-2.074c-.938-.473-1.984-.71-3.139-.71H7.36z"
        fill="#fff"
      />
      <path fill="#FF8585" d="M131.195 4h8.032v8h-8.032z" />
      <path fill="#FFB84F" d="M144.582 4h8.032v8h-8.032z" />
      <path fill="#7AE448" d="M157.969 4h8.032v8h-8.032z" />
    </svg>
  );
}


export function BgShape({
  mainClassName,
  fillClassName,
}) {
  return (
    <svg
      width={261}
      height={151}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={mainClassName}
      viewBox="0 0 261 151"
    >
      <path
        opacity={0.5}
        d="M130.5 0L261 75.5 130.5 151 0 75.5 130.5 0z"
        fill="#E5E4EE"
        className={fillClassName}
      />
    </svg>
  );
}
